import React, { useState, useEffect, useContext } from "react"

import CourseTree from "./components/tree/CourseTree"
import SelectCourse from "./components/course/SelectCourse"

import CardPreview from './CardPreview'
import Logout from "./pages/Logout"
import axios from 'axios'
import { UserContext } from './hooks/UserContext';
import { ContentContext } from "./hooks/ContentContext";

import './css/WebView.css';

export default function WebView({ props }) {
  const [content, setContent] = useState("");
  const [selectedCourse, setSelectedCourse] = useState({});
  const [selectedTopic, setSelectedTopic] = useState({});
  const [selectedCard, setSelectedCard] = useState();

  const { user } = useContext(UserContext);

  useEffect(() => {
    const getContent = async () => {
      // when selected node in tree is Topic
      if (!selectedCard && selectedTopic) {
        setContent("This is a Topic")
      };

      if (selectedCard) { // need to have card id before request
        const card = await getCard(selectedCard.id);
        setContent(card.body);
      }
    }
    getContent();
  }, [selectedCard]);

  useEffect(() => setContent(content), [content]);


  const getCard = async (cardId) => {
    let data = [];

    try {
      const res = await axios.get(`/api/cards/${cardId}`, {
        headers: { 'Authorization': `Bearer ${user.token}`, 'X-EDITOR': 'nanoms' }
      });
      data = res.data;
    } catch (error) {
      console.error(error);
    }
    return data

  }

  const getTopic = async (topicId) => {
    let data = [];

    try {
      const res = await axios.get(`/api/topics/${topicId}`, {
        headers: { 'Authorization': `Bearer ${user.token}`, 'X-EDITOR': 'nanoms' }
      });
      data = res.data;
    } catch (error) {
      console.error(error);
    }
    return data

  }

  const handleCourseChange = (currentCourse) => {
    setSelectedCourse(currentCourse);
    setSelectedTopic({});
  };

  const handleTopicChange = async (currentTopicId) => {
    console.log(`Our topic to update is ${currentTopicId}`)
    const currentTopic = await getTopic(currentTopicId);
    setSelectedTopic(currentTopic);
    setSelectedCard(null);
    console.log(`We changed topic and selected topic is ${currentTopic.name}`)
  };

  const handleCardChange = async (currentCardId, currentTopicId) => {
    console.log(`Our card to update is ${currentCardId}`)
    const card = await getCard(currentCardId);
    const topic = await getTopic(currentTopicId);
    setSelectedCard(card);
    setSelectedTopic(topic);
  };

  return (
    <div className="App">
      <ContentContext.Provider value={{ selectedCourse, handleCourseChange }}>
        <div className="WebView">
          <div className="title">
            <h2> Nerdish Viewer</h2>
            <div className="left-title">
              <Logout />
            </div>
          </div>
          <div className="active-area">
            <div className="course-tree">
              <div className="course-elements">
                <SelectCourse
                  onCourseSelect={handleCourseChange}
                  selectedCourse={selectedCourse}
                />
              </div>
              <CourseTree
                selectedCourse={selectedCourse}
                selectedTopic={selectedTopic}
                selectedCard={selectedCard}
                onTopicSelect={handleTopicChange}
                onCardSelect={handleCardChange}
                canEdit={false}
              />
            </div>
            <div className="preview">
              <CardPreview content={content}
                selectedCourse={selectedCourse}
                selectedTopic={selectedTopic} />
            </div>
          </div>
        </div>
      </ContentContext.Provider>
    </div>
  )
}






